import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const SubsectionPubsCreate: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'subsectionPub';
    return (
        <Cw8Create
            resourceName = {resourceName}
        ></Cw8Create>
    );
    
};
